var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct container"},[_c('titletag',{attrs:{"title":"404 Page Not Found"}}),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("404 Page not found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }